"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const base_models_1 = require("@integration/base-models");
const GetPropositionAttributesResponseKey_1 = tslib_1.__importDefault(require("./GetPropositionAttributesResponseKey"));
class GetPropositionAttributesResponse extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetPropositionAttributesResponseKey_1.default),
    tslib_1.__metadata("design:type", Array)
], GetPropositionAttributesResponse.prototype, "attributes", void 0);
exports.default = GetPropositionAttributesResponse;
